// Page d'accueil publique (présente le service Falko aux visiteurs non connectés).
// Sert aussi à la vérification Meta : « site web terminé présentant le service + infos entreprise ».

import { Link } from 'react-router-dom';
import { Footer } from '../components/shared/Footer';

const FEATURES = [
  {
    emoji: '👀',
    title: 'Falko comprend chaque commentaire',
    text: 'Positif, question, client·e prêt·e à acheter, ou commentaire délicat : Falko analyse chaque message avant de répondre.',
  },
  {
    emoji: '✍️',
    title: 'Des réponses dans ta voix',
    text: 'Falko apprend ta voix de marque et propose des réponses qui te ressemblent vraiment, pas des réponses robotisées.',
  },
  {
    emoji: '✅',
    title: 'Tu gardes le contrôle',
    text: 'Tu valides, modifies ou ignores chaque suggestion. Rien n’est publié sans ton accord.',
  },
];

export const Landing = () => (
  <div className="min-h-screen bg-neutral-50 flex flex-col">
    {/* En-tête */}
    <header className="border-b border-neutral-200 bg-white">
      <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img src="/falko-icon-1024.png" alt="Falko" className="w-8 h-8 rounded-lg" />
          <span className="text-xl font-semibold text-neutral-900">Falko</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Link to="/login" className="px-3 py-1.5 rounded-lg text-neutral-600 hover:bg-neutral-100 transition">
            Se connecter
          </Link>
          <Link
            to="/register"
            className="px-4 py-1.5 rounded-lg bg-violet-600 text-white font-medium hover:bg-violet-700 transition"
          >
            Créer un compte
          </Link>
        </div>
      </div>
    </header>

    {/* Hero */}
    <main className="flex-1">
      <section className="max-w-3xl mx-auto px-6 pt-16 pb-12 text-center">
        <img src="/falko-icon-1024.png" alt="" className="w-20 h-20 rounded-2xl mx-auto mb-6 shadow-sm" />
        <h1 className="text-3xl sm:text-4xl font-bold text-neutral-900 leading-tight">
          Réponds à tes commentaires Instagram dans ta voix, sans y passer tes journées.
        </h1>
        <p className="mt-4 text-lg text-neutral-600">
          Falko est un assistant qui comprend les commentaires reçus sur ton compte Instagram
          professionnel et te propose des réponses fidèles à ta voix de marque. Tu valides ou modifies, Falko publie.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link
            to="/register"
            className="px-6 py-3 rounded-xl bg-violet-600 text-white font-medium hover:bg-violet-700 transition"
          >
            Commencer
          </Link>
          <Link
            to="/login"
            className="px-6 py-3 rounded-xl border border-neutral-300 text-neutral-700 font-medium hover:bg-neutral-100 transition"
          >
            Se connecter
          </Link>
        </div>
      </section>

      {/* Fonctionnalités */}
      <section className="max-w-5xl mx-auto px-6 pb-16 grid gap-6 sm:grid-cols-3">
        {FEATURES.map((f) => (
          <div key={f.title} className="bg-white rounded-2xl border border-neutral-200 p-6">
            <div className="text-3xl mb-3">{f.emoji}</div>
            <h2 className="font-semibold text-neutral-900 mb-1">{f.title}</h2>
            <p className="text-sm text-neutral-600">{f.text}</p>
          </div>
        ))}
      </section>

      {/* Pour qui + éditeur */}
      <section className="max-w-3xl mx-auto px-6 pb-16 text-center">
        <h2 className="text-xl font-semibold text-neutral-900 mb-2">Pour qui ?</h2>
        <p className="text-neutral-600">
          Pour les créatrices, coachs, community managers et marques qui veulent rester proches de leur communauté
          sur Instagram sans passer des heures à répondre aux commentaires.
        </p>
        <p className="mt-6 text-sm text-neutral-400">
          Falko est édité par <strong className="font-medium text-neutral-500">SpAIce Lab</strong> (Christel
          Bussière, EI). Connexion via l’API officielle Instagram, avec ton autorisation explicite.
        </p>
      </section>
    </main>

    <Footer />
  </div>
);
